import React from 'react';

import './WaveEffect.scss';

function WaveEffect() {
  return (
    <div className="waves-container">
      <svg
        className="waves"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        shapeRendering="auto"
      >
        <g className="parallax">
          <path
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            x="48"
            y="0"
            fill="rgba(54, 57, 62, 0.7)"
          />
          <path
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            x="48"
            y="3"
            fill="rgba(54, 57, 62, 0.5)"
          />
          <path
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            x="48"
            y="5"
            fill="rgba(54, 57, 62, 0.3)"
          />
          <path
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            x="48"
            y="7"
            fill="rgba(37, 38, 42, 0.9)"
          />
        </g>
      </svg>
    </div>
  );
}

export default React.memo(WaveEffect);
